import type { CmxRumApi } from './rum-api';

const stubRUM: CmxRumApi = {
  startView: () => {},
  addAction: () => {},
  addError: () => {},
  setUser: () => {},
  setUserProperty: () => {},
  clearGlobalContext: () => {},
};

export function getRUM(): CmxRumApi {
  const rum = (window as Window & { DD_RUM?: CmxRumApi }).DD_RUM;
  return rum ?? stubRUM;
}
